'use strict'
import axios from 'axios'

export default class Config {
    static getConfig() {
        if (process.env.NODE_ENV === 'development') return axios.get('/api/_staticfiles16/catalogo/js/trocachipconfig');
        return axios.get('../_staticfiles16/catalogo/js/trocachipconfig.txt')
    }
}
